import { configureStore } from '@reduxjs/toolkit';
import {
  authReducer,
  GUILD_FEATURE_KEY,
  guildReducer,
  REWARDS_FEATURE_KEY,
  rewardsReducer,
  systemReducer,
} from './features';
import { profileReducer } from '@/store/features/profile.slice';
import { baseApi } from '@/store/services';

const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    profile: profileReducer,
    system: systemReducer,
    [GUILD_FEATURE_KEY]: guildReducer,
    [REWARDS_FEATURE_KEY]: rewardsReducer,
  },
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware().concat(baseApi.middleware)],
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
